import { render, staticRenderFns } from "./SensitiveDataTab.vue?vue&type=template&id=b2c4a614&scoped=true"
import script from "./SensitiveDataTab.vue?vue&type=script&lang=js"
export * from "./SensitiveDataTab.vue?vue&type=script&lang=js"
import style0 from "./SensitiveDataTab.vue?vue&type=style&index=0&id=b2c4a614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c4a614",
  null
  
)

export default component.exports